<template>
  <div style="text-align: left;">
    <!-- 卡片-查询表单 -->
    <div class="md-layout card-form">
      <div class="md-layout-item md-layout md-size-30 md-xsmall-size-100" :style="{'padding':'0'}">
        <md-field>
          <label>{{$I18n("user_id")}}</label>
          <md-input v-model="searchForm.user_id"/>
        </md-field>
      </div>
      <div class="md-layout-item md-size-60 md-xsmall-size-100" :style="{'text-align':'left'}">
        <md-button class= "left-icon md-info" @click="form_changeSearchData">
          <md-icon>search</md-icon>
          {{$I18n("search")}}
        </md-button>
      </div>
    </div>
    <div v-if="info && info.api">
      <div style="margin: 15px; height: 1; width: 100%; text-align: center; font-weight: bold; font-size: 16px; color: #888888;">{{$I18n("datacenter")}}</div>
      <md-table v-model="infoData">
        <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('belong_data_center')">{{ item.zone_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('gateway_1')">{{ item.addr }}</md-table-cell>
          <md-table-cell :md-label="$I18n('h5_enter')">{{ item.h5 }}</md-table-cell>
        </md-table-row>
      </md-table>
      <div style="margin: 15px; height: 1; width: 100%; text-align: center; font-weight: bold; font-size: 16px; color: #888888;">{{$I18n("user")}}</div>
      <md-table v-model="tableData">
        <!-- ID  账号 邮箱  手机 注册APP  登录时间 登录IP 注册时间 -->
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('zone')">{{ item.zone_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('user_id')">{{ item.user_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('email')">{{ item.mail }}</md-table-cell>
          <md-table-cell :md-label="$I18n('phone')">{{ item.phone }}</md-table-cell>
          <md-table-cell :md-label="'APP'">{{ item.app_name }}</md-table-cell>
          <md-table-cell :md-label="$I18n('app_id')">{{ item.app_id }}</md-table-cell>
          <md-table-cell :md-label="$I18n('login_date')">{{ item.login_time }}</md-table-cell>
          <md-table-cell :md-label="$I18n('login_ip')">{{ item.ip }}</md-table-cell>
          <md-table-cell :md-label="$I18n('created_time')">{{ item.create_time }}</md-table-cell>
        </md-table-row>
        <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
      </md-table>
    </div>
    <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
  </div>
</template>
<script>
import {timestampToString} from "@/common/tools.js";
import {countryMap} from "@/common/continent.js";

export default {
  props: {
    userinfo_sys:{
      type: String,
      default: "",
    },
    app_list:{
      type: Array,
      default: function(){
        return []
      },
    }
  },
  data() {
    return {
      searchForm : {
        user_id:"",
      },
      searchData : {
        user_id:"",
      },
      info:{},
      tableInitData : [], // 表格数据
      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,
    };
  },
  watch: { 
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage(){
      this.api_getPageData()
    },
  },
  computed: {
    infoData(){
      if(!this.info.api){
        return []
      }
      return [{
        user_id: this.searchData.user_id,
        addr   : this.info.api.addr,
        h5     : this.info.h5.addr,
        zone_name : countryMap[this.info.api.zone] 
          ?countryMap[this.info.api.zone][this.$router.history.current.query.lang !== "en" ? "cn_name" :"name"]
          :"",
      }]
    },
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            const masterAppInfo = this.app_list.filter(app => app.id === item.master_id)[0];
            return {
              ...item,
              app : masterAppInfo ?masterAppInfo.name :"",
              zone_name : this.info && this.info.api && countryMap[this.info.api.zone] 
                ?countryMap[this.info.api.zone][this.$router.history.current.query.lang !== "en" ? "cn_name" :"name"]
                :"",
              create_time: item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
              login_time : item.gmt_login ?timestampToString(item.gmt_login * 1000) :"",
            }
          })
      }
    },
  },
  methods: {
    // API-表格数据
    api_getPageData(){
      this.$api.getUserDetail({
        ...this.searchData,
      })
        .then(this.$Then(res => {
          this.tableInitData = [];
          this.total = 0;
          this.info = res.data;
          this.$api.getAppUserList_otherAddr({
            ...this.searchData,
            sys      : this.userinfo_sys,
            comp_id  : this.UserInfo.role_id < 10000 ?0 :this.UserInfo.comp_id,
            page_size: this.pageSize,
            page_no  : this.currentPage,

            _api_server: this.info.api.scheme + "://" + this.info.api.addr + "/api",
          })
            .then(this.$Then(res => {
              this.tableInitData = res.data;
              this.total  = res.count
            }))
            .catch(this.$Catch(this.$I18n("get_error"),() => {
              this.tableInitData = [];
              this.total  = 0;
            }))
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.info={};
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.searchData = {
        user_id: this.searchForm.user_id,
      };
      if(this.searchData.user_id){
        this.api_getPageData();
      } else {
        this.$errorMsg(this.$I18n("pls_input") + " UID")
      }
    },
  },
}
</script>